import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { FinalizarSituacaoResidenteModel, SituacaoResidenteModel } from '@shared/models/backend'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class SituacaoResidenteService {
  constructor(private http: HttpClient) {}

  saveSituacaoResidente(matriculaId: number, form) {
    return this.http.post<SituacaoResidenteModel>(`/api/residentes/${matriculaId}/situacao`, form).pipe(take(1))
  }

  editarSituacaoResidente(matriculaId: number, situacaoResidenteId: number, form) {
    return this.http
      .put<SituacaoResidenteModel>(`/api/residentes/${matriculaId}/situacao/${situacaoResidenteId}`, form)
      .pipe(take(1))
  }

  finalizarSituacaoResidente(matriculaId: number, situacaoResidenteId: number, form) {
    return this.http
      .put<FinalizarSituacaoResidenteModel>(
        `/api/residentes/${matriculaId}/situacao/${situacaoResidenteId}/finalizar`,
        form
      )
      .pipe(take(1))
  }

  excluirSituacao(matriculaId: number, situacaoResidenteId: number): Observable<boolean> {
    return this.http.delete<boolean>(`/api/residentes/${matriculaId}/situacoes/${situacaoResidenteId}`).pipe(take(1))
  }

  loadSituacaoResidente(matriculaId: number, situacaoId: number) {
    return this.http.get<SituacaoResidenteModel>(`/api/residentes/${matriculaId}/situacao/${situacaoId}`).pipe(take(1))
  }

  loadLastSituacaoResidente(matriculaId: number) {
    return this.http.get<SituacaoResidenteModel>(`/api/residentes/${matriculaId}/situacao/last`).pipe(take(1))
  }
}
